import React from "react";
import { Link } from "react-router-dom";

const Footer = () => (
  <footer className="bg-surface border-t border-border py-8 mt-12">
    <div className="max-w-6xl mx-auto px-4 flex flex-col md:flex-row items-center md:items-start justify-between gap-8">
      <div className="flex flex-col items-center md:items-start gap-2">
        <Link to="/" className="flex items-center space-x-2 mb-2">
          <img src="/images/logo.png" alt="Logo" className="max-w-[160px] w-auto" />
        </Link>
        <p className="text-sm text-text-secondary max-w-xs text-center md:text-left">
          Effortlessly sync your playlists between Spotify and YouTube Music. Secure, fast, and privacy-focused.
        </p>
      </div>

      {/* Quick Links */}
      <div className="flex flex-col items-center md:items-end gap-2">
        <span className="text-base font-semibold text-text-primary mb-1">
          Quick Links
        </span>
        <Link
          to="/privacy-policy"
          className="text-sm text-text-secondary hover:text-primary transition"
        >
          Privacy Policy
        </Link>
        <Link
          to="/terms-and-conditions"
          className="text-sm text-text-secondary hover:text-primary transition"
        >
          Terms & Conditions
        </Link>
      </div>
    </div>

    {/* Copyright */}
    <div className="mt-8 border-t border-border pt-8 text-center text-xs text-text-muted">
      &copy; {new Date().getFullYear()} PlaylistSync. All rights reserved.
    </div>
  </footer>
);

export default Footer;
